import { SUBSCRIBE_SOURCE_URL_PARAM_NAME } from './Constants';

export const getCmpQueryMap = () => {
  const searchStr = window.location.search;
  const queryMap = new URLSearchParams(searchStr);
  if (searchStr && queryMap.has('cmpid')) {
    const cmpQuery = queryMap.get('cmpid');
    const cmpQueryStr = cmpQuery.replace(/::/g, '&');
    return new URLSearchParams(cmpQueryStr);
  }
};

const formatSubscribeSrc = (value) => {
  switch (value) {
    case 'vizio':
      return 'foxnation_vizio';
    default:
      return value;
  }
};

// if url params object isn't provided then this is merely a function called to check
export const checkAndSetSubscribeSrcParam = (urlParams = undefined) => {
  const cmpQueryMap = getCmpQueryMap();
  if (cmpQueryMap?.get('src')) {
    if (urlParams) {
      urlParams.set(SUBSCRIBE_SOURCE_URL_PARAM_NAME, formatSubscribeSrc(cmpQueryMap.get('src')));
    }
    return true;
  }
  return false;
};
